import { moreNavItems, primaryNavItems, type MoreNavItem } from '@/lib/data';

export const SITE_SKIP_LINK_LABEL = 'Skip to main content';
export const SITE_MAIN_ID = 'main-content';
export const SITE_LOGO_LABEL = 'Alfa.';

export type SiteNavItem = {
  name: string;
  href: string;
};

export const sitePrimaryNav: SiteNavItem[] = primaryNavItems.map((item) => ({
  name: item.name,
  href: item.href,
}));

export const siteMoreNav: MoreNavItem[] = moreNavItems;

export function getAllSiteDestinations(): SiteNavItem[] {
  return [
    ...sitePrimaryNav,
    ...siteMoreNav.map((item) => ({ name: item.name, href: item.href })),
  ];
}
